import AppEnvironment from '../../../../components/enums/appEnvironment.enum';
import LangEnum from '../../../../lang/LangEnum';
import { Brand } from '../../../context/ApplicationContext/applicationContext.types';
import { IntegrationConfigName } from '../../../integrations/integrations.types';
import { OfflineStatus } from '../../../offline/domain/offlineOrder/offlineOrder.types';
import { Ability, ResourceType, RoleBehaviorCapability } from '../../../users/ability.types';
import { UserRole } from '../../../users/roles';
import { OrderStatus } from '../../interfaces/order-status.interface';
import { OrderType, StatusType, SynchronizedType } from '../../order.types';
import { OrderGatewayPaymentStatus } from '../../payment/enums/orderPaymentGatewayStatus.enum';
import { OrderPaymentStatus } from '../../payment/orderPayment.types';
import { ActionEnum } from './orderActions.types';

export interface GetActionsParams {
  hasSplit: boolean;
  splitted: boolean;
  status: OrderStatus | OfflineStatus;
  archivedOrder: boolean;
  loggedin?: boolean;
  isSystemParamsResetIntegration?: boolean;
  isEnableAcceptSuggestedOrder?: boolean;
  isEnableShareSuggestedOrder?: boolean;
  sellerCanCreateOrChangeSuggestedOrder?: boolean;
  hasIntegrations: boolean;
  synchronized: SynchronizedType;
  userAbility: Ability;
  triggerIntegrationConfig?: OrderStatus;
  integrationName?: IntegrationConfigName;
  canForceReverseOrderSync?: boolean;
  brand?: Brand;
  removeActions?: ActionEnum[];
  hasOrderIntegration: boolean;
  userHasNotInternet?: boolean;
  role: UserRole;
  orderPaymentStatus: OrderPaymentStatus;
  requirePaymentGateway: boolean;
  requirePaymentReleaseForImmediate: boolean;
  requirePaymentReleaseForPreOrder: boolean;
  orderType: OrderType;
  lastGatewayPaymentStatus: OrderGatewayPaymentStatus | null;
  lastGatewayPaymentUpdatedAt: Date | null;
  refundLimitHours: number;
  isArchivedOrderFilterActive?: boolean;
  appEnvironment: AppEnvironment | undefined;
}

export enum Role {
  ADMIN = 'ADMIN',
  ADMIN_MARCA = 'ADMIN_MARCA',
  ADMIN_LOJA = 'ADMIN_LOJA',
  COMPRADOR = 'COMPRADOR',
  VENDEDOR = 'VENDEDOR',
}

export const AdminAndBrandAdmin: Role[] = [Role.ADMIN, Role.ADMIN_MARCA];

export type RoleType = UserRole | undefined;

export interface ActionsType {
  icon: React.ReactNode;
  label: LangEnum;
  value: ActionEnum;
  conditions: {
    massAction: boolean;
    // TODO: ESSES NOMES ESTÃO MUITO ESTRANHOS, statusAbility e statusRole
    statusRole: Partial<Record<StatusType | OfflineStatus, RoleType[]>>;
    appEnvironment: ReadonlyArray<AppEnvironment>;
    statusAbility?: Partial<Record<StatusType | OfflineStatus, ResourceType[]>>;
    statusCapability?: Partial<Record<StatusType | OfflineStatus, RoleBehaviorCapability[]>>;
    isAllowed?: (params: Readonly<GetActionsParams>) => boolean;
  };
  testId?: string;
}

export type ActionsToRemoveType = Array<ActionEnum | undefined>;

export interface PrimaryActionParams {
  status: OrderStatus | OfflineStatus;
  role: Role;
  userHasInternet: boolean;
  appEnvironment: AppEnvironment | undefined;
}

export interface GetActionsToRemoveBasedOnGatewayPaymentParams {
  params: GetActionsParams;
  role: UserRole;
  ability: Ability;
  integrationTrigger?: OrderStatus;
}
